import Select from './select'

export const AmuiSelect = Select

export default Vue => Vue.component(Select.name, Select)
